/**
 * Идентификация участника-переговорки (транскодер) по `connectionType`.
 */
import { ConnectionType, Participant } from '@yandex-video-platform/goloom-sdk';

export function isTranscoderParticipant(participant: Participant): boolean {
    return participant.connectionType === ConnectionType.CONNECTION_TYPE_SIP;
}
